var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('HealthCheck',{attrs:{"menuNameLower":_vm.menuNameLower,"menuNameUpper":_vm.menuNameUpper}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }